import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const assetService = {
  list: async (params = {}) => (await apiClient.get(ENDPOINTS.assets, { params })).data,
  get: async (id) => (await apiClient.get(ENDPOINTS.asset(id))).data,
  create: async (payload) => (await apiClient.post(ENDPOINTS.assets, payload)).data,
  update: async (id, payload) => (await apiClient.patch(ENDPOINTS.asset(id), payload)).data,
  delete: async (id) => (await apiClient.delete(ENDPOINTS.asset(id))).data,
  expiringWarranties: async (withinDays = 30) =>
    (await apiClient.get(ENDPOINTS.assetExpiringWarranties, { params: { within_days: withinDays } })).data,
  assign: async (id, employeeId) =>
    (await apiClient.post(ENDPOINTS.assetAssign(id), { employee_id: employeeId })).data,
  unassign: async (id) => (await apiClient.post(ENDPOINTS.assetUnassign(id))).data,
  linkTicket: async (id, ticketId) =>
    (await apiClient.post(ENDPOINTS.assetLinkTicket(id), { ticket_id: ticketId })).data,
};
